import React from 'react';
import { Outlet } from 'react-router-dom';

const Booking = () => {
    return (
        <div className=''>
            <Outlet />
        </div>
    );
};




export default Booking;
